<template>
  <section class="row g-3 row-cols-lg-2 row-cols-1">
    <article class="col areaPos">
      <div>
        <slot name="one"></slot>
      </div>
    </article>
    <article class="col areaPos">
      <div>
        <slot name="two"></slot>
      </div>
    </article>
  </section>
</template>

<style scoped>

.areaPos{
  padding: 0 6%;
}
div {
  width: 100%;
}
section {
  padding: 0 10%;
  width: 100%;
  margin:0;
}
.border {
  border: 1px solid #1B1C1E;
}

article {
  display: flex;
  align-items: center;
  text-align:justify;
}
</style>

<style>
.imagetext-img {
  width: 100%;
  height: 600px;
  object-fit: cover;
  object-position: 40%;
}
.imagetext-img-phone {
  width: 100%;
  height: 300px;
  object-fit: cover;
  object-position: right;
}
.imagetext-headline {
  display: flex;
  justify-content: center;
  padding: 12px 18px;
}
.imagetext-text{
  display: flex;
  justify-content: center;
  padding: 0 12%;
}
</style>
